import type { ReactNode } from 'react';
import { Icon } from './Icon';
import { useIsMobile } from '../../hooks/useIsMobile';

/**
 * Quello che dal telefono non si fa.
 *
 * Riconciliazioni, procedure a più passi, tabelle di confronto larghe: mostrarle
 * a metà è peggio che non mostrarle. Al loro posto va una riga onesta che dice
 * cosa c'è lì dentro e dove si fa, con la stessa calma del resto dell'app.
 *
 * Tre cose che questa riga NON deve fare, mai:
 *  - sembrare un errore (niente rosso, niente triangolo di allarme);
 *  - lasciare lo schermo vuoto senza spiegazione;
 *  - promettere che "presto arriverà anche qui" se non è vero.
 *
 * Uso:
 *   <DesktopOnly cosa="La riconciliazione degli incassi">
 *     <TabellaRiconciliazione … />
 *   </DesktopOnly>
 */
export function DesktopOnly({
  children,
  /** Come si chiama la cosa, in italiano, iniziando con la maiuscola. */
  cosa,
  /** Perché non ci sta sul telefono. Una riga, concreta. */
  perche = 'è una tabella da confrontare riga per riga, e su uno schermo stretto si legge male.',
}: {
  children: ReactNode;
  cosa: string;
  perche?: string;
}) {
  const mobile = useIsMobile();
  if (!mobile) return <>{children}</>;

  return (
    <div className="m-desk-note" role="note">
      <Icon name="help" size={14} />
      <span>
        <strong>{cosa}</strong> si fa dal computer: {perche}
      </span>
    </div>
  );
}
